/**
 * @file コンポーネント：フォームプルダウン スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { mediaQuery } from "~/src/styles/mixins";

// スタイル
export const StyledPulldown = styled.div`
    display: inline-block;
    position: relative;
    border-radius: 4px;

    ${mediaQuery.pcWide(`
        flex: 1;
        text-align: right;
    `)};

    &::after {
        position: absolute;
        top: 0;
        right: 4px;
        bottom: 0;
        z-index: 1;
        width: 24px;
        height: 24px;
        margin: auto 0;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        content: "\f0d7";
    }

    &[data-on-color="gray"] {
        background-color: #ffffff;

        &::after {
            color: #7e7e7e;
        }
    }

    &[data-on-color="main"] {
        &::after {
            color: #808385;
        }
    }

    &[data-on-color="sub"] {
        &::after {
            color: #929496;
        }
    }

    &[data-on-color="white"] {
        &::after {
            color: #7e7e7e;
        }
    }

    &.is-wide {
        width: 100%;
    }
`;

export const StyledPulldownSelect = styled.select`
    position: relative;
    z-index: 2;
    width: 100%;
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    background-color: transparent;
    line-height: 24px;

    &[data-on-color="gray"] {
        padding: 8px 26px 8px 10px;
        border-color: #7e7e7e;
        color: #25292d;
        font-size: 16px;
    }

    &[data-on-color="main"] {
        padding: 4px 28px 4px 12px;
        border-color: #808385;
        color: #e3e3e4;
        font-size: 16px;
    }

    &[data-on-color="sub"] {
        padding: 4px 28px 4px 12px;
        border-color: #929496;
        color: #929496;
        font-size: 12px;
    }

    &[data-on-color="white"] {
        padding: 8px 26px 8px 10px;
        border-color: #7e7e7e;
        color: #25292d;
        font-size: 16px;
    }
`;

export const StyledPulldownSelectOption = styled.option`
    color: #000000;
`;
